import { render } from "./MostPopularArticle.vue?vue&type=template&id=6101b228"
import script from "./MostPopularArticle.vue?vue&type=script&lang=js"
export * from "./MostPopularArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__